import { render } from "./ReplacementReserve.vue?vue&type=template&id=2013f816&scoped=true"
import script from "./ReplacementReserve.vue?vue&type=script&lang=js"
export * from "./ReplacementReserve.vue?vue&type=script&lang=js"

import "./ReplacementReserve.vue?vue&type=style&index=0&id=2013f816&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2013f816"]])

export default __exports__